import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
const colon = (obj) => {
    //@ts-expect-error non checked
    return Object.fromEntries(Object.entries(obj).map(([key]) => [key, `:${key}`]));
};
const paramsOne = z.object({
    telegram_channel_id: z.coerce.number().int().transform(String),
});
const patternOne = ({ telegram_channel_id, }) => telegram_channel_id;
const PATH_ONE = patternOne(colon(paramsOne.keyof().enum));
const pathOne = (p) => {
    return `${PREFIX}/${patternOne(p)}`;
};
//////////////////////////////////////////////////// contracts
export const PREFIX = 'channel-request';
const channelReference = z.union([
    z.object({
        username: z.string().min(1),
    }),
    z.object({
        invite_hash: z.string().min(1),
    }),
]);
export var putExistentAccount;
(function (putExistentAccount) {
    /*
  
    export const PATH = 'existent-account';
  
    export const path = () => `${PREFIX}/${PATH}`;
  
    */
    putExistentAccount.body = z.object({
        channel: channelReference,
    });
    class Body extends createZodDto(putExistentAccount.body) {
    }
    putExistentAccount.Body = Body;
})(putExistentAccount || (putExistentAccount = {}));
export var putNewAccount;
(function (putNewAccount) {
    const account = z.object({
        name: z.string().min(1),
    });
    /*
  
    export const PATH = 'new-account';
  
    export const path = () => `${PREFIX}/${PATH}`;
  
    */
    putNewAccount.body = z.object({
        account,
        channel: channelReference,
    });
    class Body extends createZodDto(putNewAccount.body) {
    }
    putNewAccount.Body = Body;
})(putNewAccount || (putNewAccount = {}));
export var deleteOne;
(function (deleteOne) {
    deleteOne.PATH = PATH_ONE;
    deleteOne.path = pathOne;
    class Params extends createZodDto(paramsOne) {
    }
    deleteOne.Params = Params;
})(deleteOne || (deleteOne = {}));
export var getOne;
(function (getOne) {
    getOne.PATH = PATH_ONE;
    getOne.path = pathOne;
    class Params extends createZodDto(paramsOne) {
    }
    getOne.Params = Params;
})(getOne || (getOne = {}));
//# sourceMappingURL=channel-request.js.map